import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { Upscale4K } from "@/components/landing/Upscale4K";
import { Benefits } from "@/components/landing/Benefits";
import { Features } from "@/components/landing/Features";
import { ArtTemplates } from "@/components/landing/ArtTemplates";
import { UniquenessReport } from "@/components/landing/UniquenessReport";
import { CrmService } from "@/components/landing/CrmService";
import { BotsService } from "@/components/landing/BotsService";
import { Pricing } from "@/components/landing/Pricing";
import { MoreFeatures } from "@/components/landing/MoreFeatures";
import { ContactForm } from "@/components/landing/ContactForm";
import { Footer } from "@/components/landing/Footer";
import { PaymentReturn } from "@/components/landing/PaymentReturn";

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-[#050507] text-white" data-testid="landing-page">
      <PaymentReturn />
      <Navbar />
      <main>
        <Hero />
        <Upscale4K />
        <Benefits />
        <Features />
        <ArtTemplates />
        <UniquenessReport />
        <CrmService />
        <BotsService />
        <Pricing />
        <MoreFeatures />
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
}
